import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import SearchPage from './pages/SearchPage'
import RecommendationsPage from './pages/RecommendationsPage'
import MixerPage from './pages/MixerPage'
import BlendBankPage from './pages/BlendBankPage'
import './App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<SearchPage />} />
            <Route path="/recommendations/:trackId" element={<RecommendationsPage />} />
            <Route path="/mixer" element={<MixerPage />} />
            <Route path="/blend-bank" element={<BlendBankPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  )
}

export default App
